module.exports = __webpack_public_path__ + "static/media/cross.2367f035.svg";